import {
  FETCH_ESTIMATE,
  FETCH_ESTIMATE_SUCCESS,
  FETCH_ESTIMATE_FAILED,
  CLEAR_ESTIMATE
} from "../store/types";
import Polyline from '@mapbox/polyline';
import { firebase } from '../config/configureFirebase';
import { FareCalculator } from '../other/FareCalculator';
import { onValue } from "firebase/database";

export const getEstimate = (bookingData) => async (dispatch) => {
  const   {
      settingsRef,
      additionalFeesRef
  } = firebase;

  dispatch({
    type: FETCH_ESTIMATE,
    payload: bookingData,
  });
          

  let res = bookingData.routeDetails;

  if(res){
    let points = Polyline.decode(res.polylinePoints);

    let waypoints = points.map((point) => {
        return {
            latitude: point[0],
            longitude: point[1]
        }
    });
    
    onValue(settingsRef, settingdata => {
      let settings = settingdata.val();
      let distance = settings.convert_to_mile? (res.distance_in_km / 1.609344) : res.distance_in_km;

     let {totalCost, grandTotal, convenience_fees} = FareCalculator(distance, res.time_in_secs, bookingData.carDetails, bookingData.instructionData, settings.decimal);
      onValue(additionalFeesRef, feesSnap => {
        const feeRows = feesSnap.val() || {};
        const baseFare = grandTotal ? parseFloat(grandTotal) : 0;
        const additionalFees = Object.keys(feeRows).filter((id) => feeRows[id] && feeRows[id].active !== false).map((id) => {
          const fee = feeRows[id];
          const rateType = fee.rateType || "flat";
          const value = fee.amount !== undefined ? parseFloat(fee.amount) : 0;
          const calculatedAmount = rateType === "percentage" ? (baseFare * value / 100) : value;
          return {
            id,
            name: fee.name || "",
            rateType,
            rate: isNaN(value) ? 0 : value,
            amount: parseFloat((isNaN(calculatedAmount) ? 0 : calculatedAmount).toFixed(settings.decimal))
          };
        });
        const additionalFeesTotal = additionalFees.reduce((total, fee) => total + parseFloat(fee.amount || 0), 0);
        const finalFare = baseFare + additionalFeesTotal;
        dispatch({
          type: FETCH_ESTIMATE_SUCCESS,
          payload: {
            pickup:bookingData.pickup,
            drop:bookingData.drop,
            carDetails:bookingData.carDetails,
            instructionData: bookingData.instructionData,
            estimateDistance: parseFloat(distance).toFixed(settings.decimal),
            fareCost: totalCost ? parseFloat(totalCost).toFixed(settings.decimal) : 0,
            baseEstimateFare: baseFare.toFixed(settings.decimal),
            estimateFare: finalFare ? parseFloat(finalFare).toFixed(settings.decimal) : 0,
            additionalFees,
            additionalFeesTotal: additionalFeesTotal.toFixed(settings.decimal),
            estimateTime:res.time_in_secs,
            convenience_fees: convenience_fees ? parseFloat(convenience_fees).toFixed(settings.decimal) : 0,
            waypoints: waypoints
          },
        });
      }, {onlyOnce:true});
    }, {onlyOnce:true});
  }else{
    dispatch({
      type: FETCH_ESTIMATE_FAILED,
      payload: "No Route Found",
    });
  }

}

export const clearEstimate = () => (dispatch) => {
    dispatch({
        type: CLEAR_ESTIMATE,
        payload: null,
    });    
}
